import { render, staticRenderFns } from "./RoleEdit.vue?vue&type=template&id=1d56908a&scoped=true"
import script from "./RoleEdit.vue?vue&type=script&lang=js"
export * from "./RoleEdit.vue?vue&type=script&lang=js"
import style0 from "./RoleEdit.vue?vue&type=style&index=0&id=1d56908a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56908a",
  null
  
)

export default component.exports